import { render, staticRenderFns } from "./AchievementsCarousel.vue?vue&type=template&id=5352b4e6&scoped=true&"
import script from "./AchievementsCarousel.vue?vue&type=script&lang=js&"
export * from "./AchievementsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AchievementsCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AchievementsCarousel.vue?vue&type=style&index=1&id=5352b4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352b4e6",
  null
  
)

export default component.exports